import { render, staticRenderFns } from "./NewRoomType.vue?vue&type=template&id=86082fe8&"
import script from "./NewRoomType.vue?vue&type=script&lang=js&"
export * from "./NewRoomType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports